export const REVYRE = {
  COLLECT_IQ: {
    WORKFLOW_TYPES: ['batch', 'ccase', 'loan'],
    DOMAIN_TYPES: [
      'activity',
      'workflow',
      'approval',
      'payment',
      'supervisorReview',
    ],
    LIST_PAGE_CREATE_SCENARIO_BLOCKED_ENTITIES: ['ccase', 'loan', 'payment'],
    RESTRICT_HEADER_BUTTONS: ['loan'],
    DETAILS_PAGE_QUICK_ACTIONS_HIDDEN_RULES: {
      hiddenByInputKey: 'suspended',
    },
    DETAILS_PAGE_CUSTOM_REFFERED_ENTITIES: ['payment'],
    STATUS_ERROR_CODE_WITH_DESCRIPTION: [50008],
    SHOW_BULK_REASSIGN_BUTTON_IN_LIST_PAGE: ['ccase'],
    SHOW_BULK_REVOKE_BUTTON_IN_LIST_PAGE: ['ccase'],
  },
};

export const STATE_ID = 'stateId';
export const DISPOSITION_GROUP = 'outcomeGroup';

export const REVYRE_FORM_CREATE_TYPE = 'create';
export const REVYRE_FORM_DETAILS_CREATE_TYPE = 'detailsCreate';
